<!-- 
	搜索组件 Z10
	1、背景颜色
	2、框体样式： 圆角、方角
	3、搜索框边线颜色
	4、搜索框底色颜色
	5、搜索框透明度
	6、提示文字
	7、文字颜色
	8、搜索按钮
	9、搜索图标
-->
<template>
	<view class="search" :style="wrapperStyle">
		<!-- 搜索组件 -->
		<view class="search-inner" :style="searchStyle" @click="toSearch">
			<up-image v-if="data.searchUrl" :src="getImageUrl(data.searchUrl)" width="32px" height="32px" style="margin-left: -3px;" shape="circle"></up-image>
			<u-icon v-if="!data.searchUrl" name="search" :style="iconStyle" :size="22"></u-icon>
			<view type="text" :value="data.placeholderText == null ? '请输入搜索内容' : data.placeholderText" :style="inputStyle" ref="inputValue" :border="false">
				{{data.placeholderText == null ? '请输入搜索内容' : data.placeholderText}}
			</view>
			<view class="search_btn f_c_c_c" :style="{'background-color':vuex_skinColor}">搜索</view>
			<!-- <up-image v-if="data.btnUrl" :src="getImageUrl(data.btnUrl)" width="32px" height="32px" shape="circle"></up-image> -->
		</view>
	</view>
</template>
<!--
"decorateSearchBarBo": {
	"id": "49c01c1f740711f0a3479c5c8ebcfe65",
	"borderColor": "#31C9A3",
	"barBackgroundColor": "#FFFFFF",
	"barTransparency": 0,
	"placeholderText": "请输入搜索内容",
	"textColor": "#000000",
	"btnUrl": "",
	"searchUrl": "",
	"companyId": "1",
	"shopId": "1",
	"decorateId": "ad0507d26f9f11f0a3479c5c8ebcfe65",
	"decorateModuleId": "49bf22d6740711f0a3479c5c8ebcfe65",
	"createTime": "2025-08-08 11:25:10"
}
-->

<script setup>
	import {fnImgRequestPath} from "@/utils/utils";
	import { getCurrentInstance, reactive, ref, computed} from "vue";
	const { ctx } = getCurrentInstance(); //获取上下文实例，ctx=vue2的this
	const props = defineProps({
		componentId: {
			type: String,
			default: ''
		},
		data: {
			type: Object,
			default () {
				return {
					//组件样式 1 圆角 2 方角
					chooseStyle: {
						type: String,
						default: '1'
					},
					//背景颜色
					backgroundColor: {
						type: String,
						default: '#FFFFFF'
					},
					//搜索框底色颜色
					barBackgroundColor:{
						type: String,
						default: '#FFFFFF'
					},
					//搜索框透明度
					barTransparency:{
						type: Number,
						default: 0
					},
					// 边框颜色
					borderColor: {
						type: String,
						default: "#b0b0ba"
					},
					//文本位置
					textAlign: {
						type: String,
						default: 'left'
					},
					//文本内容
					placeholderText: {
						type: String,
						default: '请输入搜索内容'
					},
					//文本颜色
					textColor: {
						type: String,
						default: '#000000'
					},
					//搜搜按钮地址
					btnUrl: {
						type: String,
						default: ''
					},
					//搜索图片地址
					searchUrl: {
						type: String,
						default: ''
					}
				}
			}
		}
	})
	
	/**
	 * 组件样式
	 */
	const wrapperStyle = computed(() => {
		const {
			backgroundColor
		} = props.data;
		return `
			width: 100%;
			background-color: ${backgroundColor == null ? '#FFFFFF' : backgroundColor};
			background-size: 100% auto;
			bakcground-position: center;
		`;
	})
	
	/**
	 * 搜索框样式
	 */
	const searchStyle = computed(() => {
		const {
			barBackgroundColor,
			chooseStyle,
			borderColor,
			textAlign,
			barTransparency
		} = props.data;
		
		return `
			background: ${barBackgroundColor};
			width: 96%;height: 70%;
			border-radius: ${chooseStyle === '2' ? 0 : 60}px;
			border: 1px solid ${borderColor == null ? '#909D99' : borderColor};
			display: flex;
			overflow: hidden;
			justify-content:  ${textAlign == null ? 'left' : textAlign};
			color:${borderColor == null ? '#909D99' : borderColor};
			opacity: ${barTransparency == 0 ? 1 : 1 - barTransparency/100};
		`;
	})
	
	/**
	 * 输入框样式
	 */
	const inputStyle = computed(() => {
		const {
			barBackgroundColor,
			textColor,
			textAlign
		} = props.data;
		return `
			justify-content: ${textAlign == null ? 'left' : textAlign};
			color:${textColor == null ? '#909D99' : textColor};
			background: ${barBackgroundColor};
			border:${textColor == null ? '#909D99' : textColor};
			margin-left:5px;
			width:100%;
		`;	
	})
	
	/**
	 * 图标样式
	 */
	const iconStyle = computed(() => {
		const {
			borderColor
		} = props.data;
		return `
			color:${borderColor};
			margin-left:8px;
		`;
	})
	
	/**
	 * 搜索跳转
	 */
	function toSearch() {
		uni.hideKeyboard()
		uni.navigateTo({
			url: '/pages/search/search?type=4',
			animationType: 'fade-in'
		});
		ctx.$u.vuex('vuex_isSerarchBack', false);
	}
	
	/**
	 * 获取图片地址
	 */
	function getImageUrl(imgUrl){
		return fnImgRequestPath(imgUrl);
	}
	
</script>

<style lang="less" scoped>
	.search {
		width: 100%;
		height: 52px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	/* 搜索区域 */
	.search-inner {
		position: relative;
		width: 92%;
		height: 70%;
		display: flex;
		align-items: center;
		justify-content: center;
		padding-left: 3px;
	}

	.search-inner div {
		display: inline-block;
		width: 100%;
	}

	.search-inner input {
		width: 373px;
		display: block;
		height: 100%;
		text-indent: 20px;
		border: 0;
		color: #b0b0ba;
		box-sizing: border-box;
		margin-top: -1px;
	}

	.ivu-icon-ios-search {
		font-size: 21px;
		
	}
	
	.search_btn {
		/* 按钮样式 */
		// max-width: 120rpx;
		// height: auto;
		align-items: center;
		/* 垂直居中 */
		// line-height: 58rpx;
		padding: 0 20rpx;
		color: white;
		border-radius: 28rpx;
		margin-right: 6rpx !important;
		// margin-top: 2rpx;
		// margin-bottom: 2rpx;
		font-size: 28rpx;
		/* 去除按钮默认样式 */
		// border: none;
		// outline: none;
		height: 90%;
		width: 136rpx;
	}
</style>
